import { RiArrowLeftSLine } from 'react-icons/ri';
import { IoCheckmarkCircleOutline, IoInformationCircleOutline } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import feedback from 'assets/img/experienceCatalog/feedback.png';
import { useCallback, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { ExperienceCatalogQuestions } from 'types/experienceCatalog';
import {
  fetchFeedbackExperienceCatalog,
  fetchQuestionExperienceCatalog,
  getDeadLineExperienceCatalog,
  getRegulationExperienceCatalog,
  loadExperiencePurchase,
  registerFeedbackExperienceCatalog,
  undoExperiencePurchase,
} from 'services/experienceCataolog.service';
import { useAuth } from 'context/AuthContext';
import { StarRating } from 'components/starRating';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { getNamedDates } from 'services/utils';
import TabTitle from 'components/tab-title';
import { getLiveloPoints, getServerTime } from 'services/dashboard.service';
import {
  canAccessExperienceCatalog,
  canUndoPurchase,
  getExperienceTypeTitle,
  stripCatalogPrefix,
} from 'utils/experience-catalog';
import {
  CatalogPeriod,
  catalogClosedMessage,
  formatCatalogPeriodRange,
  readCatalogPeriod,
} from 'utils/catalog-period';
import { ART_WIDTH_PX, ART_HEIGHT_PX, IMAGE_BAND_MIN_HEIGHT_PX } from '../cardArt';

const formatCycleName = (cycleTitle: string): string => {
  const match = cycleTitle?.match(/(\d)S(\d{4})/);
  if (!match) return '';
  const semester = match[1] === '1' ? 'primeiro' : 'segundo';
  const year = match[2];
  return `${semester} semestre de ${year}`;
};

export default function ExperienceCatalogFeedbackPage() {
  Modal.setAppElement('#root');
  const navigate = useNavigate();

  const { userInfo, realCycle, cycleSelected } = useAuth();

  
  const [question, setQuestion] = useState<ExperienceCatalogQuestions[]>();
  const [ratings, setRatings] = useState<Record<number, number>>({});
  const [comentario, setComentario] = useState('');
  const [identificar, setIdentificar] = useState(false);
  const [experienceInfo, setExperienceInfo] = useState<{
    title: string;
    description: string;
    date: Date | null;
    type: string;
    regrasDeUso?: any;
    valor?: string;
    total?: string;
    /* Os três campos do complemento, copiados do `extra` do achievement. A frase exibida vem
       de `description`, montada pelo motor; estes ficam para quem precisar do número.
       `totalCartao` é number — o relatório de admin o exibe com o filtro `number:2`. */
    totalCartao?: number;
    totalPontos?: number;
    totalDias?: number;
    /* A arte do item, também do `extra`: é ela que monta a faixa do card desta página. */
    image?: string;
    /* Aviso do motor (só no combo de espécie sem saldo de Pontos Joga Junto). Repetido aqui
       porque esta é a tela em que o jogador confere o que escolheu. */
    aviso?: string;
    /* Valor em espécie do resgate (R$), presente só nos combos de espécie.
       Ele existia para esconder a linha "N Pontos Livelo" do painel; essa linha saiu inteira
       com a `D-14`, então hoje nada o lê — fica como o `extra` o entrega, para quem for
       exibir o valor em reais nesta tela. */
    valorEspecie?: number;
  } | null>({
    title: '',
    description: '',
    date: null,
    type: '',
    regrasDeUso: undefined,
    valor: undefined,
    total: undefined,
    totalCartao: undefined,
    totalPontos: undefined,
    totalDias: undefined,
    image: undefined,
    aviso: undefined,
    valorEspecie: undefined,
  });
  const [showRulesModal, setShowRulesModal] = useState(false);
  const [rulePage, setRulePage] = useState(0);
  const [ruleUrl, setRuleUrl] = useState('');
  const [hasFeedback, setHasFeedback] = useState(false);
  const [loading, setLoading] = useState(true);
  const [secondLoad, setSecondLoad] = useState(true);
  const [endEvent, setEndEvent] = useState(false);
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);
  const [activeCycleObj, setActiveCycleObj] = useState<any>();
  const [realDatetime, setRealDatetime] = useState<number>(Date.now());
  const [hasTime, setHasTime] = useState(false);
  const [deadLine, setDeadLine] = useState<Date>();
  const [catalogPeriod, setCatalogPeriod] = useState<CatalogPeriod>({});
  const [hasLiveloPoints, setHasLiveloPoints] = useState(false);
  const [showUndoModal, setShowUndoModal] = useState(false);
  const [undoing, setUndoing] = useState(false);
  /* O cancelamento tem uma etapa a mais: confirmado o gesto, a tela diz o que aconteceu com
     os pontos antes de devolver o jogador ao catálogo. Navegar direto, como era, deixava a
     devolução dos pontos sem nenhuma confirmação visível. */
  const [undone, setUndone] = useState(false);

  const handleStarClick = (questionIndex: number, rating: number) => {
    setRatings(prev => ({
      ...prev,
      [questionIndex]: rating,
    }));
  };

  const handleTabChange = (cycle: any) => {
    setActiveCycleObj(cycle);
  };

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);
      setHasTime(true);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  useEffect(() => {
    if (!realCycle) return;
    // O teto precisa acompanhar o da página do catálogo (`../index.tsx`): as duas montam a
    // mesma lista de ciclos, e o jogador transita entre elas pelo redirect. Quando ficou em
    // `ciclo_2S2025` aqui e `ciclo_1S2026` lá, o 1S2026 sumia desta página — a consulta caía
    // no ciclo errado e nem o bloco "Experiência confirmada" nem a ação de cancelar
    // apareciam. Um gate em `__tests__/cycle-ceiling.spec.ts` prende as duas juntas.
    const minCycleDate = getNamedDates().ciclo_1S2025;
    const maxCycleDate = getNamedDates().ciclo_1S2026;
    const cycleOptions = realCycle
      .filter((item: any) => item.date_start >= minCycleDate && item.date_start <= maxCycleDate)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;
        return cycle;
      });

    setOptionsCycle(cycleOptions);
    if (!activeCycleObj && cycleOptions.length > 0) {
      setActiveCycleObj(cycleOptions.find((e) => e._id === cycleSelected?._id) || cycleOptions[0]);
    }
  }, [activeCycleObj, cycleSelected?._id, realCycle]);

  const verifyExperience = useCallback(async () => {
    setSecondLoad(true);
    try {
      if (!userInfo || !userInfo.chave || !activeCycleObj?.title) {
        return;
      }
      const response = await loadExperiencePurchase(userInfo.chave, activeCycleObj?.title);
      const rule = await getRegulationExperienceCatalog(activeCycleObj?.title);
      if (response) {
        setExperienceInfo({
          title: response.extra.title || '',
          description: response.extra.description || '',
          date: response.time || null,
          type: response.extra.type || '',
          regrasDeUso: response.extra.regrasDeUso || undefined,
          valor: response.extra.valor || undefined,
          total: response.extra.total || undefined,
          totalCartao: response.extra.totalCartao ?? undefined,
          totalPontos: response.extra.totalPontos ?? undefined,
          totalDias: response.extra.totalDias ?? undefined,
          image: response.extra.image || undefined,
          aviso: response.extra.aviso || undefined,
          valorEspecie: typeof response.extra.valorEspecie === 'number' ? response.extra.valorEspecie : undefined,
        });
      } else {
        setExperienceInfo(null);
      }
      if (rule) {
        setRuleUrl(rule.file?.url || '');
      }
      setSecondLoad(false);
    } catch (error) {
      console.error('Error verifying experience:', error);
      setSecondLoad(false);
    }
  }, [userInfo, activeCycleObj]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userInfo || !userInfo.chave) {
        return;
      }
      if (!activeCycleObj) {
        return;
      }
      setLoading(true);
      const result = await fetchQuestionExperienceCatalog();
      const feedback = await fetchFeedbackExperienceCatalog(userInfo.chave, activeCycleObj?.title);
      const deadLineResponse = await getDeadLineExperienceCatalog(activeCycleObj?._id);

      let endDate;
      if (deadLineResponse.endDate?.$date) {
        endDate = new Date(deadLineResponse.endDate.$date);
      } else if (typeof deadLineResponse.endDate === 'string') {
        endDate = new Date(deadLineResponse.endDate);
      } else if (deadLineResponse.endDate instanceof Date) {
        endDate = deadLineResponse.endDate;
      } else {
        console.error('Invalid endDate format:', deadLineResponse.endDate);
        endDate = new Date(realDatetime);
      }

      setDeadLine(endDate);
      setCatalogPeriod(readCatalogPeriod(deadLineResponse));

      // Os mesmos pontos do extrato. Falha na leitura só omite o aviso; não derruba a tela.
      const [pontosDoCiclo] = await getLiveloPoints(activeCycleObj?._id).catch(() => []);
      setHasLiveloPoints(Number(pontosDoCiclo?.total_pontos_livelo) > 0);

      if (deadLineResponse && endDate < new Date(realDatetime)) {
        setEndEvent(true);
      } else {
        setEndEvent(false);
      }

      setQuestion(result);
      setHasFeedback(feedback && feedback.length > 0);
      setLoading(false);
    };


    if (userInfo?.chave && activeCycleObj?._id) {
      fetchData();
      verifyExperience();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, verifyExperience, activeCycleObj]);


  useEffect(() => {
    // `!undone` protege a tela de sucesso: sem resgate ativo, este efeito manda o jogador de
    // volta ao catálogo — que é exatamente o estado em que ele fica ao cancelar. Sem a
    // guarda, o redirect engoliria a confirmação e o cancelamento voltaria a acontecer sem
    // nenhum sinal na tela. Quem decide voltar, agora, é o botão da própria confirmação.
    if (!experienceInfo && !endEvent && !loading && !secondLoad && !undone) {
      navigate('/catalogo-de-experiencias-list');
    }
  }, [navigate, experienceInfo, endEvent, loading, secondLoad, undone]);

  // `hasTime` garante que `realDatetime` já é o relógio do servidor, e não o `Date.now()`
  // do navegador com que o estado nasce; `secondLoad` garante que `experienceInfo` já é a
  // resposta de `loadExperiencePurchase`, e não o objeto vazio inicial.
  const showUndoAction = hasTime && !secondLoad && canUndoPurchase(!!experienceInfo, realDatetime, deadLine);

  /*
   * O prazo VENCIDO é um estado próprio, e não a ausência do botão.
   *
   * Antes, passado o prazo, a ação simplesmente sumia da tela — o jogador não tinha como
   * saber se nunca houve cancelamento ou se ele perdeu a data. Agora o botão continua
   * visível, desabilitado, e o aviso diz que o prazo expirou e quando.
   *
   * `hasTime` garante que a comparação usa o relógio do SERVIDOR: com `Date.now()`, um
   * navegador adiantado mostraria "expirado" para quem ainda pode cancelar.
   */
  const prazoExpirado = hasTime && !secondLoad && !!experienceInfo && !!deadLine && realDatetime > deadLine.getTime();
  const prazoFormatado = deadLine ? deadLine.toLocaleDateString('pt-BR') : '';
  const textoPrazoEncerrado = catalogClosedMessage(
    formatCatalogPeriodRange(catalogPeriod),
    formatCycleName(activeCycleObj?.title),
    hasLiveloPoints,
  );

  /*
   * O NOME da experiência, como o card e o modal de cancelar devem dizê-lo.
   *
   * É o título do item sem o prefixo de catalogação ("(Combo 28) - "), o mesmo que o card do
   * catálogo mostra no `<h2>`. Difere de `escolhaExibida()` de propósito: aquela é a FRASE
   * calculada, com valor, que o bloco "Experiência confirmada" e o modal de regras exibem;
   * esta é o nome curto, que o card repete no topo e o modal de cancelar cita para o jogador
   * saber o que está prestes a perder. As duas telas que nomeiam leem daqui, porque nomear a
   * experiência em cada uma por conta própria já divergiu três vezes nesta página.
   */
  const nomeExibido = (): string => {
    if (!experienceInfo) return '';

    /* A MESMA regra de nome do card do catálogo: a premiação isolada é nomeada pelo tipo e
       pelo valor — "177.500 Pontos Livelo", "Cartão premiação no valor de R$4.792,50" — e o
       combo, pelo nome sem o prefixo. Sem isto, o mesmo item aparecia com o total no
       catálogo e sem ele aqui, que é a divergência que este card foi refeito para acabar.

       O recuo para o nome cobre o resgate de ciclo anterior, que chega sem `valor`. */
    if (experienceInfo.type && experienceInfo.type !== 'combo' && experienceInfo.valor) {
      return getExperienceTypeTitle(experienceInfo.type, experienceInfo.valor);
    }

    return stripCatalogPrefix(experienceInfo.title);
  };

  /*
   * A tarja "unico"/"combo" do card, igual à do catálogo — mesmas cores, mesmo canto.
   *
   * Fica à ESQUERDA porque a arte dos itens traz o selo da Livelo no canto superior direito,
   * e a tarja caía em cima dele. O canto esquerdo está livre nas 31 artes do 1S2026.
   */
  const tarjaDeTipo = (
    <span
      className={`absolute left-4 top-4 ${
        experienceInfo?.type === 'combo' ? 'bg-purple' : 'bg-[#3962FF]'
      } rounded-full px-4 py-1 text-xs font-medium text-white`}
      role="status"
      aria-label={`Tipo de experiência: ${experienceInfo?.type === 'combo' ? 'Combinação' : 'Única'}`}
    >
      {experienceInfo?.type === 'combo' ? 'combo' : 'único'}
    </span>
  );

  /* A `develop` derivava daqui um `resgateEmEspecie`, para esconder a linha "N Pontos Livelo"
     do painel no combo de espécie — o jogador lia "R$ 3.323,82" na frase e veria o mesmo
     valor em pontos logo abaixo, em outra unidade. A linha inteira saiu com a `D-14`, junto
     de todas as outras menções a pontos nesta tela, então não há mais o que esconder: o
     problema deixou de existir com o elemento que o causava. */

  /*
   * O que o jogador escolheu, como ele deve ler em TODA tela desta página.
   *
   * É a frase que o motor calcula e grava em `extra.description` — "2 dias livres + Cartão
   * premiação no valor de R$ 12.875,27" — com recuo para o nome sem o prefixo de
   * catalogação quando o resgate é de ciclo anterior e não a traz.
   *
   * Existe como fonte única porque já divergiu três vezes: o bloco "Experiência confirmada"
   * mostrava o texto estático do item, depois o título com "(Combo 5) - " na frente, e o
   * modal de cancelar e o de regras de uso mostravam o `title` cru — sem valor e com o
   * prefixo. Cada tela repetia a mesma decisão por conta própria, e bastava esquecer uma:
   * o modal de regras só apareceu quando o gate passou a contar as chamadas.
   */
  const escolhaExibida = (): string => {
    if (!experienceInfo) return '';

    const frase = experienceInfo.type === 'combo' ? experienceInfo.description : '';

    return frase || stripCatalogPrefix(experienceInfo.title);
  };

  const undoPurchase = async () => {
    if (!activeCycleObj?.title) {
      return;
    }

    setUndoing(true);
    try {
      await undoExperiencePurchase(activeCycleObj.title);
      setShowUndoModal(false);
      setUndone(true);
    } catch (error: any) {
      // A mensagem vem do corpo do HTTP 500 da trigger — prazo encerrado, sem resgate ativo,
      // ciclo sem período configurado. O serviço já a entregou pronta para exibir.
      setShowUndoModal(false);
      toast.error(error?.message || 'Não foi possível cancelar o resgate. Tente novamente.');
    } finally {
      setUndoing(false);
    }
  };

  const sendFeedback = async () => {
    try {
      if (!userInfo || !userInfo.chave) {
        return;
      }

      const feedbackData = Object.entries(ratings).map(([questionIndex, rating]) => {
        const questionId = question?.[parseInt(questionIndex)]?._id;
        return {
          questionId,
          rating,
          pergunta: question?.[parseInt(questionIndex)]?.pergunta,
        };
      });
      const response = await registerFeedbackExperienceCatalog(userInfo.chave, comentario, feedbackData, identificar, activeCycleObj?.title);
      console.log('Feedback enviado com sucesso:', response);
      setHasFeedback(true);
    } catch (error) {
      console.error('Error sending feedback:', error);
    }
  };

  if (loading) {
    return (
      <div
        className="text-center text-white flex flex-col items-center justify-center min-h-screen"
        role="status"
        aria-live="polite"
        aria-label="Carregando conteúdo da página"
      >
        <ArticlePlaceholder />
        <ArticlePlaceholder />
        <span className="sr-only">Carregando informações do catálogo de experiências...</span>
      </div>
    );
  }

  return (
    <div className="text-white min-h-screen">
      <header className="flex flex-col items-start py-10 container mx-auto lg:p-10 mb-10">
        <div className="flex flex-row mb-4 justify-between items-center w-full">
          <div className="flex flex-row items-center gap-4">
            <Link
              to="../"
              className="rounded-full bg-purple flex justify-center items-center p-3 mr-4 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:outline-none transition-all hover:bg-purple-700"
              aria-label="Voltar para página anterior"
            >
              <RiArrowLeftSLine size={28} className="text-white" />
            </Link>
            <h1
              className="text-lg lg:text-3xl py-1 px-6 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 transition-all"
              tabIndex={0}
              role="banner"
              aria-label="Página de feedback: Catálogos de Experiências"
            >
              Catálogos de Experiências
            </h1>
          </div>
          {optionsCycle?.length > 0 && (
            <div className="z-50 relative">
              <TabTitle
                options={optionsCycle}
                title={<p>Selecione o ciclo do catálogo:</p>}
                onCallBack={handleTabChange}
                hideLabel={true}
              />
            </div>
          )}
        </div>
      </header>

       {activeCycleObj?.date_start >= getNamedDates().ciclo_2S2025 && (
        <section className="mt-[-78px] mb-10 container mx-auto pt-5 pb-7 px-10" aria-labelledby="deadline-section">
          <div className=" px-7 lg:flex border-electric-blue border-2 rounded-2xl bg-oxford-blue py-5 ">
            <div className={`'w-full -my-5 py-5 pr-0 lg:pr-[70px] pl-3'}`}>
              <p className="text-lg text-yellow" tabIndex={0}>
                O crédito da premiação está condicionado a verificação de impedimentos, conforme IN 403-1, item 1.6. A
                verificação do impedimento terá como base a situação apurada no dia anterior ao pagamento do ciclo.
              </p>
            </div>
          </div>
        </section>
      )}

      <section aria-labelledby="experience-status">
        <div className="bg-maastricht-blue flex flex-col md:flex-row items-center py-12 px-4">
          {undone ? (
            /* ETAPA DE SUCESSO DO CANCELAMENTO.
               Antes o `undoPurchase` navegava direto para o catálogo, e o cancelamento
               acontecia sem nenhuma confirmação visível — o jogador via a tela trocar e tinha
               de deduzir o que ocorreu. Aqui a tela diz o que aconteceu, e a volta ao catálogo
               passa a ser uma escolha dele.

               O texto NÃO fala em pontos devolvidos (`D-14`): o saldo Livelo volta sozinho, e
               anunciar o número aqui fazia o jogador achar que precisava conferir a conta. O
               que ele precisa saber é que o resgate caiu e até quando dá para escolher outro. */
            <div
              className="container mx-auto flex max-w-xl flex-col items-center gap-4 px-10 text-center"
              role="status"
              aria-live="polite"
            >
              <IoCheckmarkCircleOutline aria-hidden="true" className="text-6xl text-blue-light" />
              <h2 className="text-3xl font-semibold text-blue-light" tabIndex={0}>
                Cancelamento realizado!
              </h2>
              <p className="text-lg" tabIndex={0}>
                Você cancelou o resgate da sua experiência e poderá escolher outra experiência até{' '}
                <span className="text-yellow">{prazoFormatado}</span>.
              </p>
              <button
                type="button"
                onClick={() => navigate('/catalogo-de-experiencias-list')}
                className="mt-2 rounded-lg bg-yellow px-8 py-3 font-bold text-oxford-blue transition-all hover:bg-yellow-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue"
              >
                Ver Catálogo de Experiência
              </button>
            </div>
          ) : !!experienceInfo ? (
            <div className="container mx-auto flex flex-col items-center gap-10 px-10 lg:flex-row lg:items-center">
              <div className="flex-1">
                <h2
                  id="experience-status"
                  className="text-4xl font-semibold text-electric-blue mb-4 max-w-2xl relative focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                  tabIndex={0}
                >
                  Parabéns! Você escolheu viver uma experiência.
                </h2>
                <div className="mt-8 gap-4 font-light">
                  <p
                    className="max-w-2xl text-xl text-center md:text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                    tabIndex={0}
                    role="status"
                    aria-label="Informações da experiência confirmada"
                  >
                    Experiência confirmada:{' '}
                    <span className="text-yellow">
                      {experienceInfo?.valor && experienceInfo.type === 'pontos_Livelo' && experienceInfo?.valor}{' '}
                      {experienceInfo?.total && experienceInfo.type === 'dias_livres' && experienceInfo?.total}{' '}
                      {/* Uma linha só, com o valor.
                          O combo tinha um parágrafo próprio logo abaixo, e ele repetia esta
                          linha inteira acrescentando o valor no fim — "Por dentro do BBDW
                          Brasília + Cartão premiação" seguido de "Por dentro do BBDW
                          Brasília + Cartão premiação no valor de R$ 178,20". A frase
                          completa passou para cá e o parágrafo saiu.

                          O recuo para o título cru cobre o resgate de ciclo anterior, sem os
                          campos de complemento: a linha volta a ser só o nome. */}
                      {escolhaExibida()}
                    </span>
                    <br />
                    {experienceInfo?.aviso && (
                      <span role="note" className="block mt-1 text-sm text-yellow">
                        {experienceInfo.aviso}
                      </span>
                    )}
                    {experienceInfo?.valor && experienceInfo.type === 'cartao' && (
                      <>
                        valor:{' '}
                        <span className="text-yellow">
                          {experienceInfo.type === 'cartao' ? 'R$' : ''} {experienceInfo?.valor}
                        </span>
                      </>
                    )}
                  </p>
                  <p
                    className="max-w-2xl text-xl text-center md:text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                    tabIndex={0}
                    role="status"
                    aria-label="Data de confirmação da experiência"
                  >
                    Data da confirmação:{' '}
                    <span className="text-yellow">
                      {experienceInfo.date ? new Date(experienceInfo.date).toLocaleDateString('pt-BR') : 'Carregando...'}
                    </span>
                  </p>
                  <div className="flex text-sm mt-2 items-center gap-1">
                    <span>Ver</span>
                    <button
                      className="font-bold underline hover:no-underline focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-1 focus-visible:outline-none rounded-sm py-1 transition-all"
                      onClick={() => setShowRulesModal(true)}
                      aria-label="Abrir modal com regras de uso da experiência"
                    >
                      regras de uso
                    </button>
                    <span>e</span>
                    <a
                      className="font-bold underline hover:no-underline focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-1 focus-visible:outline-none rounded-sm py-1 transition-all"
                      href={ruleUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Abrir regulamento em nova aba (abre em nova janela)"
                    >
                      regulamento
                    </a>
                    <span>.</span>
                  </div>

                </div>
              </div>
              {/* O CARD DA EXPERIÊNCIA ESCOLHIDA.
                  A ação de cancelar mora aqui, junto do que ela cancela — antes era um botão
                  solto no fim do texto, longe do item a que se referia.

                  É a MESMA casca do card do catálogo (`ExperienceSelectCard`), e não um card
                  parecido: mesma largura, mesma borda por tipo, mesma faixa de arte em
                  `object-contain` na proporção de `cardArt`, mesmo `<h2>` grande, mesma linha
                  da estrela, e o botão colado embaixo separado pela borda tracejada. O jogador
                  escolheu olhando um card; aqui ele vê o que escolheu do mesmo jeito.

                  A ilustração que ficava entre o texto e o card saiu: com o card ao lado ela
                  só disputava espaço com aquilo que a tela existe para mostrar.

                  O que NÃO veio do catálogo é o flip: as regras de uso desta tela já moram no
                  modal aberto pelo link "regras de uso", logo ao lado. Dois caminhos para a
                  mesma coisa seria pior que um. */}
              <aside
                className={`w-[300px] shrink-0 overflow-hidden rounded-xl border-2 bg-[#002647] ${
                  experienceInfo?.type === 'combo' ? 'border-purple' : 'border-[#3962FF]'
                }`}
                aria-label="Experiência escolhida"
              >
                {!!experienceInfo?.image && (
                  <div
                    className="relative w-full bg-[#002647]"
                    style={{ aspectRatio: `${ART_WIDTH_PX} / ${ART_HEIGHT_PX}`, minHeight: IMAGE_BAND_MIN_HEIGHT_PX }}
                  >
                    {/* `contain` e não `cover`, como no catálogo: recortar a arte decepa parte
                        do desenho sem ninguém perceber. */}
                    <img
                      src={experienceInfo?.image}
                      alt=""
                      aria-hidden="true"
                      className="h-full w-full object-contain"
                    />
                    {tarjaDeTipo}
                  </div>
                )}

                <div className="relative p-4">
                  {!experienceInfo?.image && tarjaDeTipo}
                  {/* O título sobe até quase encostar na arte. Aqui o card é o RESUMO do que já
                      foi escolhido, ao lado do texto que confirma a escolha — e não um item de
                      vitrine a ser comparado com outros, como no catálogo, onde o `mt-6` dá o
                      respiro da grade. O `mt-12` sem arte continua: é o espaço da tarja de tipo,
                      que nesse caso é desenhada sobre o topo do conteúdo. */}
                  <h3
                    className={`text-3xl font-extrabold leading-tight text-white ${
                      experienceInfo?.image ? 'mt-2' : 'mt-12'
                    }`}
                    tabIndex={0}
                  >
                    {nomeExibido()}
                  </h3>

                  {!!experienceInfo?.description && (
                    <p className="mt-4 text-sm font-extralight leading-relaxed text-white" tabIndex={0}>
                      {experienceInfo.description}
                    </p>
                  )}

                  {/* O aviso de prazo fica dentro do card, colado no botão que ele condiciona. */}
                  {(showUndoAction || prazoExpirado) && (
                    <div className="mt-4 flex gap-2 rounded-lg bg-maastricht-blue p-3 text-xs leading-relaxed text-white">
                      <IoInformationCircleOutline aria-hidden="true" className="mt-[2px] shrink-0 text-blue-light" />
                      {prazoExpirado ? (
                        <p>
                          O prazo para cancelamento desta experiência expirou em{' '}
                          <span className="text-yellow">{prazoFormatado}</span>. Não é mais possível cancelar.
                        </p>
                      ) : (
                        <p>
                          Você pode cancelar esta experiência até{' '}
                          <span className="text-yellow">{prazoFormatado}</span>. Após essa data não será mais possível
                          cancelar.
                        </p>
                      )}
                    </div>
                  )}
                </div>

                {/* O botão do catálogo, em amarelo: largura inteira, colado no pé do card e
                    separado pela borda tracejada. O prazo vencido reusa o estado de esgotado —
                    botão cinza desabilitado, e não botão ausente (`DESF-01.1`): sumir não
                    distingue "nunca deu para cancelar" de "eu perdi a data". */}
                {(showUndoAction || prazoExpirado) && (
                  <button
                    type="button"
                    onClick={() => setShowUndoModal(true)}
                    disabled={prazoExpirado}
                    className={`w-full shrink-0 border-t border-dashed border-prussian-blue py-4 font-bold transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 ${
                      prazoExpirado
                        ? 'cursor-not-allowed bg-gray-400 text-gray-100'
                        : 'bg-yellow text-oxford-blue hover:bg-yellow-400'
                    }`}
                    aria-label={
                      prazoExpirado
                        ? 'Cancelamento indisponível: o prazo desta experiência expirou'
                        : 'Cancelar esta experiência e voltar ao catálogo'
                    }
                  >
                    {prazoExpirado ? 'CANCELAMENTO INDISPONÍVEL' : 'CANCELAR EXPERIÊNCIA'}
                  </button>
                )}
              </aside>
            </div>
          ) : canAccessExperienceCatalog(userInfo) ?
            (
            <div className="flex flex-row items-center container mx-auto px-10">
              <div>
                <h2
                  className="text-4xl font-semibold text-electric-blue mb-4 max-w-2xl relative focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                  tabIndex={0}
                  role="status"
                >
                  {/* Você continua ganhando! */}
                  Prazo encerrado
                </h2>
                <div>
                  <p
                    className="max-w-2xl text-xl text-center md:text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                    tabIndex={0}
                    role="status"
                    aria-live="polite"
                  >
                    {/* O prazo para escolher sua experiência já foi encerrado, mas não se preocupe, seus pontos Livelo serão
                    creditados automaticamente na sua conta no site da Livelo.{' '} */}
                    {textoPrazoEncerrado}
                  </p>
                </div>
              </div>
              <img
                src={feedback}
                alt="Feedback"
                className="w-[300px] md:w-[520px] lg:w-[620px] right-[0%] lg:right-[20%] absolute"
              />
            </div>
          ) : (
            <div className="flex flex-row items-center container mx-auto px-10">
              <div>
                <h2
                  className="text-4xl font-semibold text-electric-blue mb-4 max-w-2xl relative focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                  tabIndex={0}
                  role="status"
                >
                  Prazo encerrado
                </h2>
                <div>
                  <p
                    className="max-w-2xl text-xl text-center md:text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-maastricht-blue transition-all"
                    tabIndex={0}
                    role="status"
                    aria-live="polite"
                  >
                    {textoPrazoEncerrado}
                  </p>
                </div>
              </div>
              <img
                src={feedback}
                alt="Feedback"
                className="w-[300px] md:w-[520px] lg:w-[620px] right-[0%] lg:right-[20%] absolute"
              />
            </div>
          )}
        </div>
      </section>

      <Modal
        isOpen={showRulesModal}
        onRequestClose={() => {
          setShowRulesModal(false);
          setRulePage(0);
        }}
        contentLabel="Modal de Regras de Uso da Experiência"
        className="bg-white rounded-xl p-6 max-w-sm w-full mx-4 relative outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        ariaHideApp={false}
        shouldFocusAfterRender={true}
        shouldReturnFocusAfterClose={true}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        aria-describedby="modal-content"
      >
        <button
          onClick={() => {
            setShowRulesModal(false);
            setRulePage(0);
          }}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 text-xl focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none rounded-full p-1 transition-all"
          aria-label="Fechar modal de regras de uso"
        >
          ✕
        </button>
        <div className="text-center">
          <h3
            id="modal-title"
            className="text-xl mb-4 text-[#002647] font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 transition-all"
            tabIndex={0}
          >
            Regras de uso
          </h3>
          <h4
            className="text-[#002647] font-bold mb-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 transition-all"
            tabIndex={0}
          >
            {escolhaExibida()}
          </h4>
          {experienceInfo?.regrasDeUso?.rules2
            ? (() => {
              const rules = [experienceInfo?.regrasDeUso?.rules1, experienceInfo?.regrasDeUso?.rules2];
              return (
                <div id="modal-content">
                  <div
                    className="text-sm text-[#002647] list-disc pl-5 space-y-1 custom-list-disc-yellow focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 transition-all"
                    dangerouslySetInnerHTML={{ __html: rules[rulePage] }}
                    tabIndex={0}
                    role="region"
                    aria-live="polite"
                    aria-atomic="true"
                    aria-label={`Conteúdo da página ${rulePage + 1} de 2 das regras de uso`}
                  />
                  <nav className="flex flex-col items-center justify-center mb-2" aria-label="Navegação das páginas de regras">
                    <div className="flex items-center gap-2 mb-1" role="tablist" aria-label="Páginas das regras de uso">
                      {[0, 1].map(idx => (
                        <button
                          key={idx}
                          type="button"
                          role="tab"
                          aria-label={`Página ${idx + 1} das regras de uso`}
                          aria-current={rulePage === idx ? 'page' : undefined}
                          aria-selected={rulePage === idx}
                          onClick={() => setRulePage(idx)}
                          className={`carousel-dot focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 focus-visible:outline-none rounded-full transition-all${rulePage === idx ? ' active' : ''}`}
                        />
                      ))}
                    </div>
                    <span
                      className="text-[#102535] text-sm font-normal leading-none"
                      role="status"
                      aria-live="polite"
                      aria-atomic="true"
                    >
                      {rulePage + 1} de 2
                    </span>
                  </nav>
                </div>
              );
            })()
            : experienceInfo?.regrasDeUso?.rules1 && (
              <div
                id="modal-content"
                className="text-sm text-[#002647] list-disc pl-5 space-y-1 custom-list-disc-yellow focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 transition-all"
                dangerouslySetInnerHTML={{ __html: experienceInfo?.regrasDeUso?.rules1 }}
                tabIndex={0}
                role="region"
                aria-label="Regras de uso da experiência"
              />
            )}
        </div>
        <div className="flex justify-center mt-6">
          <button
            onClick={() => {
              setShowRulesModal(false);
              setRulePage(0);
            }}
            className="bg-yellow text-oxford-blue px-6 py-3 rounded-lg font-bold text-lg hover:bg-yellow-400 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none transition-all"
          >
            Fechar
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={showUndoModal}
        onRequestClose={() => {
          if (!undoing) setShowUndoModal(false);
        }}
        contentLabel="Confirmação para cancelar o resgate da experiência"
        className="bg-white rounded-xl p-6 max-w-sm w-full mx-4 relative outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        ariaHideApp={false}
        shouldFocusAfterRender={true}
        shouldReturnFocusAfterClose={true}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="undo-modal-title"
        aria-describedby="undo-modal-content"
      >
        <h3 id="undo-modal-title" className="text-xl mb-4 text-[#002647] font-bold text-center" tabIndex={0}>
          Deseja cancelar esta experiência?
        </h3>
        {/* O modal NOMEIA a experiência e NÃO fala em pontos (`D-14`).
            Antes ele anunciava os pontos Livelo que voltariam, e a decisão do jogador virava
            uma conta de saldo — quando o que ele precisa confirmar é QUAL experiência está
            prestes a perder e até quando dá para escolher outra. O nome é o mesmo que o card
            atrás do modal mostra no título, por `nomeExibido()`. */}
        <p id="undo-modal-content" className="text-sm text-[#002647] text-center" tabIndex={0}>
          <strong className="block text-base">{nomeExibido()}</strong>
          <span className="mt-3 block">
            Você poderá escolher outra experiência até <strong>{prazoFormatado}</strong>.
          </span>
        </p>
        <div className="flex justify-center gap-3 mt-6">
          <button
            type="button"
            onClick={() => setShowUndoModal(false)}
            disabled={undoing}
            className="border-2 border-[#002647] text-[#002647] px-6 py-3 rounded-lg font-bold hover:bg-gray-100 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Manter o resgate e fechar a confirmação"
          >
            Não, voltar
          </button>
          <button
            type="button"
            onClick={undoPurchase}
            disabled={undoing}
            className="bg-yellow text-oxford-blue px-6 py-3 rounded-lg font-bold hover:bg-yellow-400 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Confirmar o cancelamento do resgate"
          >
            {undoing ? 'Cancelando...' : 'Sim, cancelar'}
          </button>
        </div>
      </Modal>

      {!endEvent && (
        <>
          {!hasFeedback ? (
            <main className="bg-slate-blue py-12 px-4 container mx-auto" role="main" aria-labelledby="feedback-main-heading">
              <section className="mb-8">
                <div className="flex flex-col items-start justify-start container mx-auto">
                  <h2
                    id="feedback-main-heading"
                    className="text-3xl font-bold ml-20 w-2/4 mb-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all"
                    tabIndex={0}
                  >
                    Queremos te ouvir!
                  </h2>
                  {/* O convite ficou em parágrafo, e não dentro do `<h2>`: o título é a
                      chamada curta, e a explicação — o que é a pesquisa e para que serve —
                      não é cabeçalho. Um `<h2>` de três linhas também é ruim para quem
                      navega por títulos no leitor de tela. */}
                  <p
                    className="text-lg ml-20 w-2/4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all"
                    tabIndex={0}
                  >
                    Apenas algumas perguntas sobre o Catálogo de Experiências para que possamos aprimorar nossas ações de
                    reconhecimento e premiação. Vamos lá?
                  </p>
                </div>
              </section>

              <section aria-labelledby="feedback-questions">
                <h3 id="feedback-questions" className="sr-only">
                  Perguntas de avaliação
                </h3>
                <div className="flex flex-col items-start justify-start container mx-auto px-20">
                  {question &&
                    question.map((item, index) => (
                      <fieldset
                        key={index}
                        className="mb-6 w-full bg-white rounded-lg border-slate-400 border-2 flex items-center justify-between p-6 focus-within:ring-2 focus-within:ring-yellow focus-within:ring-offset-2 transition-all shadow-md"
                      >
                        <legend className="text-xl border-slate-400 border-2 font-bold text-slate-900 px-3 py-1 bg-white">
                          Pergunta {index + 1}
                        </legend>
                        <div className="text-lg font-semibold text-slate-800 px-2 max-w-md">{item.pergunta}</div>
                        <div className="flex flex-col items-center ml-4">
                          <StarRating
                            rating={ratings[index] || 0}
                            onRating={rate => handleStarClick(index, rate)}
                            aria-label={`Avaliação de 1 a 5 estrelas para: ${item.pergunta}`}
                          />
                          <div aria-live="polite" aria-atomic="true" className="sr-only">
                            {ratings[index]
                              ? `Avaliação atual: ${ratings[index]} de 5 estrelas para "${item.pergunta}"`
                              : `Nenhuma avaliação selecionada para "${item.pergunta}"`}
                          </div>
                        </div>
                      </fieldset>
                    ))}
                </div>
              </section>
              <section className="w-full px-20 mt-4" aria-labelledby="additional-feedback">
                <div className="mb-6">
                  <label
                    htmlFor="comentario"
                    className="block text-white text-xl font-semibold mb-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all"
                    tabIndex={0}
                  >
                    Comentários e sugestões (opcional):
                  </label>
                  <textarea
                    id="comentario"
                    className="w-full h-32 rounded-md p-4 text-black focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-2 focus-visible:outline-none border-2 border-gray-300 focus:border-yellow-400 transition-all resize-vertical"
                    placeholder="O que você mais gostou nesse modelo; o que pode melhorar; etc..."
                    value={comentario}
                    onChange={e => setComentario(e.target.value)}
                    aria-describedby="comentario-hint"
                  />
                  <div id="comentario-hint" className="text-white text-sm mt-1">
                    Compartilhe suas impressões sobre a experiência escolhida
                  </div>
                </div>

                <fieldset className="mt-6 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all rounded-md p-2">
                  <legend
                    className="text-white text-lg mb-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all px-2"
                    tabIndex={0}
                  >
                    Deseja se identificar:
                  </legend>
                  <div className="flex items-center gap-6">
                    <label className="flex items-center gap-2 text-white cursor-pointer hover:bg-white/10 focus-within:bg-white/10 rounded-md p-2 transition-all">
                      <input
                        type="radio"
                        name="identificar"
                        value="nao"
                        checked={!identificar}
                        onChange={() => setIdentificar(false)}
                        className="w-4 h-4 text-yellow focus:ring-2 focus:ring-yellow focus:ring-offset-1"
                        aria-describedby="nao-identificar-desc"
                      />
                      <span>Não</span>
                      <span id="nao-identificar-desc" className="sr-only">
                        Não desejo me identificar no feedback
                      </span>
                    </label>
                    <label className="flex items-center gap-2 text-white cursor-pointer hover:bg-white/10 focus-within:bg-white/10 rounded-md p-2 transition-all">
                      <input
                        type="radio"
                        name="identificar"
                        value="sim"
                        checked={identificar}
                        onChange={() => setIdentificar(true)}
                        className="w-4 h-4 text-yellow focus:ring-2 focus:ring-yellow focus:ring-offset-1"
                        aria-describedby="sim-identificar-desc"
                      />
                      <span>Sim</span>
                      <span id="sim-identificar-desc" className="sr-only">
                        Desejo me identificar no feedback
                      </span>
                    </label>
                  </div>
                </fieldset>

                <p
                  className="text-white mt-4 max-w-2xl text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all rounded-md p-1"
                  tabIndex={0}
                  role="note"
                >
                  Essa avaliação de escolha de experiências faz parte de um teste e portanto o resultado final será utilizado
                  somente para avaliação dessa nova metodologia.
                </p>
              </section>
              {/* Botão de envio */}
              <div className="flex justify-center mt-8">
                <button
                  onClick={() => {
                    sendFeedback();
                  }}
                  className="bg-yellow text-oxford-blue px-8 py-3 rounded-lg font-bold text-xl hover:bg-yellow-400 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={!question || Object.keys(ratings).length < question.length}
                  aria-describedby={question && Object.keys(ratings).length < question.length ? 'submit-hint' : undefined}
                >
                  {!question
                    ? 'Carregando...'
                    : Object.keys(ratings).length < question.length
                      ? `Enviar Avaliação (${Object.keys(ratings).length}/${question.length})`
                      : 'Enviar Avaliação'}
                </button>
                {question && Object.keys(ratings).length < question.length && (
                  <div id="submit-hint" className="sr-only">
                    Por favor, responda todas as {question.length} perguntas para enviar sua avaliação
                  </div>
                )}
              </div>
            </main>
          ) : (
            <main className="bg-slate-blue py-12 px-4 container mx-auto" role="main">
              <section role="status" aria-live="polite" aria-labelledby="feedback-success">
                <div className="flex flex-col items-start justify-start container mx-auto">
                  <h2
                    id="feedback-success"
                    className="text-3xl font-bold ml-20 w-2/4 mb-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all"
                    tabIndex={0}
                  >
                    Agradecemos por compartilhar sua opinião!
                  </h2>
                  <p
                    className="text-xl font-normal ml-20 w-2/4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-blue transition-all"
                    tabIndex={0}
                  >
                    Seu feedback é muito importante para continuarmos melhorando nossas experiências.
                  </p>
                </div>
              </section>
            </main>
          )}
        </>
      )}
    </div>
  );
}
